import type { SalesRole } from "../../types";

/**
 * Maps an application role to the access level understood by `canAccess`.
 * Owner and admin get the administrator powers; sales and design (and any
 * unknown role) get the regular non-admin access.
 */
export const getAccessRole = (role?: SalesRole): "admin" | "user" =>
  role === "owner" || role === "admin" ? "admin" : "user";
